import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import API from "../../../utils/axios";
import { withSnackbar } from "notistack";
import {
  setVehicles,
  setChangedVehicles,
  setSelectedVehicles,
  setCurrentWindow,
  setProject,
  setVehicleTypes
} from "../../../store/actions/project";
import { setSolution } from "../../../store/actions/solution";
import { setProjects } from "../../../store/actions/account";
import {
  setExtendableId,
  setExtendableType
} from "../../../store/actions/edit";
import { plans } from "../../data/plans";
import { setInfoDialog } from "../../../store/actions/common";
import { compare, exportToXlsx } from "../../../utils/helpers";
import {
  defaultCapacity,
  defaultVolume,
  defaultWeight
} from "../../data/constants";
import CommonMaterialTable from "../commonTable/CommonMaterialTable";
import { makeStyles, Tooltip } from "@material-ui/core";
import TitleWithEducationalMaterials from "../../common/TitleWithEducationalMaterials";
// import { setInitialProjectLoading } from "../../../store/actions/loading";

const useStyles = makeStyles(theme => ({
  tooltip: {
    backgroundColor: "#fff",
    color: theme.palette.text.primary,
    fontSize: "0.8125rem",
    lineHeight: "1.1875rem",
    fontWeight: 400,
    boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.24)",
    padding: theme.spacing(1.5),
    maxWidth: "216px"
  },
  tagTooltip: {
    boxShadow:
      "0px 4px 12px rgba(0, 0, 0, 0.25), 0px 0px 2px rgba(0, 0, 0, 0.16)",
    borderRadius: "2px",
    maxWidth: "600px",
    padding: theme.spacing(1),
    backgroundColor: "#5F6368",
    color: "#fff",
    "& span": {
      display: "inline-block",
      backgroundColor: "rgba(255,255,255,.24)",
      fontSize: "1rem",
      lineHeight: "1.1875rem",
      padding: theme.spacing(0.5),
      margin: theme.spacing(0.5)
    }
  },
  customTableWrapper: {
    "& .MuiTable-root": {
      width: 1112,
      "& td, th": {
        padding: theme.spacing(0, 1.5, 0, 2.25) + " !important"
      },
      "& .MuiTableSortLabel-icon": {
        marginLeft: theme.spacing(0.25),
        marginRight: theme.spacing(0.25)
      }
    }
  }
}));

function VehiclesOverviewDialog({
  open,
  vehicles,
  vehicleTypes,
  setVehicles,
  setVehicleTypes,
  setCurrentVehicle,
  handleClose,
  setActiveDialog,
  setCurrentAction,
  project,
  projects,
  setProject,
  setProjects,
  editId,
  setSolution,
  vehicleExpanded,
  setChangedVehicles,
  vehiclesListLoaded,
  setExtendableId,
  setExtendableType,
  enqueueSnackbar,
  setUploadOpen,
  selectedVehicles,
  setSelectedVehicles,
  setInfoDialog,
  setCurrentWindow,
  plan,
  payment,
  subscriptionStatus
}) {
  const classes = useStyles();

  const [confirmDialogState, setConfirmDialogState] = useState({
    open: false,
    id: null
  });

  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);

  const sortVehiclesByName = vehicleTypes => {
    return [...vehicleTypes].sort((vehicle1, vehicle2) => {
      return compare(vehicle1.name, vehicle2.name);
    });
  };

  useEffect(() => {
    if (open) {
      setSelected([]);
    }
  }, [open]);

  const updateStateAfterVehicleDelete = ids => {
    const newVehicleTypes = vehicleTypes.filter(
      vehicleType => !ids.includes(vehicleType.id)
    );

    const newSelectedVehicles = [];
    const vehicleIds = [];

    const newVehicles = vehicles.filter((vehicle, i) => {
      if (!ids.includes(vehicle?.type_id?.id)) {
        newSelectedVehicles.push(vehicle.vehicle_id);
        return true;
      } else {
        vehicleIds.push(vehicle.vehicle_id);
        return false;
      }
    });

    // update selected vehicles
    console.log(
      selected,
      ids,
      selected.filter(el => !ids.includes(el))
    );
    setSelected(selected.filter(el => !ids.includes(el)));

    // Update project when deleting -> stops unassigned, route delete
    const newSolution = project.solution ? { ...project.solution } : null;
    if (project.solution && vehicleIds.length) {
      const routesToRemove = [];
      const newRoutes = newSolution.routes.filter(route => {
        if (vehicleIds.includes(route.vehicle_id.split("_")[0])) {
          routesToRemove.push(route);
          return false;
        }
        return true;
      });

      const tasksToUnassign = [];
      routesToRemove.forEach(route => {
        route.stops.forEach(task => {
          if (!["start", "break", "end"].includes(task.type)) {
            tasksToUnassign.push(task);
          }
        });
      });

      newSolution.routes = [...newRoutes];
      newSolution.unassigned.stops = [
        ...newSolution.unassigned.stops,
        ...tasksToUnassign
      ];
      newSolution.routeGroups = { ...project.routeGroups };
      setSolution(newSolution);
    }

    if (project.solution) {
      setChangedVehicles(vehicleIds);
    }

    if (ids.includes(editId)) {
      setExtendableType(null);
      setExtendableId(null);
    }

    const selectedLength = selectedVehicles.length;
    setSelectedVehicles(newSelectedVehicles);
    if (
      project?.solution?.routes.length &&
      !newSelectedVehicles.length &&
      selectedLength
    ) {
      // Change status
      API.patch(`v1/projects/${project.id}/status`, {
        status: "preparing"
      })
        .then(res => {
          const projectId = project.id;
          setProjects(
            projects.map(project =>
              project.id === projectId
                ? {
                    ...project,
                    solution: newSolution,
                    status: project.status ? "optimized" : "preparing"
                  }
                : { ...project, solution: newSolution }
            )
          );
        })
        .catch(error => console.log(error))
        .finally(() => {
          setProject({
            ...project,
            vehicleTypes: newVehicleTypes,
            vehicles: newVehicles,
            solution: newSolution,
            selectedVehicles: newSelectedVehicles,
            status: project.status ? "optimized" : "preparing"
          });
        });
      setCurrentWindow("Project");
    }
    setVehicles(newVehicles);
    setVehicleTypes(newVehicleTypes);
  };

  // Delete vehicle
  const deleteVehicle = vehicleType => {
    const { id, name } = vehicleType;

    setLoading(true);
    // dispatch(setInitialProjectLoading(true));
    vehicleType &&
      API.delete(`/v1/vehicles/${id}`)
        .then(res => {
          updateStateAfterVehicleDelete([id]);
          enqueueSnackbar(`Vehicle "${name}" deleted.`);
        })
        .catch(error => {
          if (error.status === 400) {
            enqueueSnackbar(
              "Can't delete vehicle, it belongs to a locked route or to a published project."
            );
          } else {
            enqueueSnackbar(
              "Something went wrong, couldn't delete the vehicle"
            );
          }
          console.dir(error);
        })
        .finally(() => {
          // dispatch(setInitialProjectLoading(false));
          setLoading(false);
        });
  };

  const handleAdd = e => {
    e && e.preventDefault();
    setCurrentAction("edit");
    setCurrentVehicle(null);
  };
  const handleEdit = vehicleType => {
    setCurrentVehicle(vehicleType.id);
    setCurrentAction("edit");
  };

  const handleDelete = vehicleType => {
    if (vehicleTypes.length <= 1) {
      setInfoDialog({
        visible: true,
        title: "Operation not possible",
        body: "Your organization has to have at least one active vehicle in order to use Routetitan."
      });
    } else {
      console.log(vehicleType);
      setConfirmDialogState({
        open: true,
        id: vehicleType.id,
        title: "Delete vehicle?",
        body: "Are you sure you want to delete this vehicle? This vehicle will be deleted from all ongoing and future projects.",
        action: () => {
          deleteVehicle(vehicleType);
        }
      });
    }
  };

  const deleteVehicles = selected => {
    setLoading(true);
    // dispatch(setInitialProjectLoading(true));

    let vehicleType;
    if (selected.length === 1) {
      vehicleType = vehicleTypes.find(item => item.id === selected[0]);
    }

    API.delete("/v1/vehicles/batch", { data: selected })
      .then(res => {
        updateStateAfterVehicleDelete(selected);

        enqueueSnackbar(
          !vehicleType
            ? `Selected vehicles deleted.`
            : `Vehicle "${vehicleType.name}" deleted.`
        );
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(
          "Something went wrong, couldn't delete selected vehicles"
        );
      })
      .finally(() => {
        // dispatch(setInitialProjectLoading(false));
        setLoading(false);
      });
  };

  const handleMultipleDelete = () => {
    // TO2DO: need endpoint
    if (vehicleTypes.length <= selected.length) {
      setInfoDialog({
        visible: true,
        title: "Operation not possible",
        body: "Your organization has to have at least one active vehicle in order to use Routetitan."
      });
    } else {
      setConfirmDialogState({
        open: true,
        title: `Delete vehicle${selected.length > 1 ? "s" : ""}?`,
        body: `Are you sure you want to delete ${selected.length} vehicle${
          selected.length > 1 ? "s" : ""
        }? ${selected.length > 1 ? "These" : "This"} vehicle${
          selected.length > 1 ? "s" : ""
        } will be deleted from all ongoing and future projects.`,
        action: () => {
          deleteVehicles(selected);
        }
      });
    }
  };

  const handleMultipleDownload = () => {
    exportToXlsx("selected_vehicles.xlsx", [
      [
        "license_plate",
        "max_units",
        "max_weight",
        "max_volume",
        "vehicle_tags"
      ],
      ...sortVehiclesByName(vehicleTypes)
        .filter(vehicleType => selected.includes(vehicleType.id))
        .map(vehicle => [
          vehicle.name,
          // vehicle.profile,
          vehicle.quantity === defaultCapacity ? null : vehicle.quantity,
          vehicle.weight === defaultWeight ? null : vehicle.weight,
          vehicle.volume === defaultVolume ? null : vehicle.volume,
          vehicle.tags?.map(el => el.name).join("; ")
        ])
    ]);
  };

  const sortAddresses = (a, b) => {
    const addr1 = a?.formatted_address || "";
    const addr2 = b?.formatted_address || "";
    return addr1 > addr2 ? 1 : -1;
  };

  const sortUnitsWeightVolume = (a, b, defaultVal) => {
    a = a === defaultVal ? "" : a;
    b = b === defaultVal ? "" : b;
    return +a - +b;
  };

  return (
    <>
      <CommonMaterialTable
        confirmDialogState={confirmDialogState}
        setConfirmDialogState={setConfirmDialogState}
        handleClose={() => {
          if (vehicleExpanded) {
            setActiveDialog("");
          } else {
            handleClose();
          }
        }}
        selected={selected}
        data={
          loading ? [] : vehicleTypes.sort((a, b) => compare(a.name, b.name))
        }
        title={
          <TitleWithEducationalMaterials
            title={"Vehicles"}
            configId={"vehicles"}
            sectionName={"vehicles"}
            showArticle
            showDivider
          />
        }
        singular="vehicle"
        plural="vehicles"
        upload={{
          enabled: !vehicleExpanded,
          setUploadOpen: setUploadOpen
        }}
        downloadable
        handleMultipleDownload={handleMultipleDownload}
        customWrapperClass={classes.customTableWrapper}
        handleDelete={handleDelete}
        handleMultipleDelete={handleMultipleDelete}
        setSelected={setSelected}
        loading={!vehiclesListLoaded || loading}
        handleAdd={
          plan &&
          plan.cap_vehicles > 0 &&
          vehicleTypes.length >= plan.cap_vehicles
            ? () =>
                setInfoDialog({
                  visible: true,
                  title:
                    subscriptionStatus === "trialing" && !payment
                      ? "Please upgrade your plan"
                      : "Please modify your plan",
                  body: `You are currently subscribed to the ${
                    plans.find(planI => planI.name === plan.type).title
                  } ${
                    subscriptionStatus === "trialing" && !payment
                      ? "(Trial)"
                      : ""
                  } plan, which has a maximum vehicle limit of ${
                    plan.cap_vehicles
                  }. Upgrade your plan to Small Business or Business in order to add more vehicles to your organization.`,
                  button: {
                    text: "Upgrade plan",
                    link: "/payment/select-plan"
                  },
                  mainButtonText: "No, thanks"
                })
            : handleAdd
        }
        handleEdit={handleEdit}
        open={open}
        columns={[
          {
            title: "License Plate",
            field: "name",
            editable: "never",
            cellStyle: {
              width: "170px"
            },
            headerStyle: {
              width: "170px"
            },
            customSort: (a, b) => {
              return compare(a.name, b.name);
            },
            render: rowData => {
              return (
                <Tooltip
                  title={rowData.name}
                  placement="bottom-start"
                  classes={{ tooltip: classes.tooltip }}
                  enterDelay={1000}
                >
                  <span id="vehiclesRow-name">{rowData.name}</span>
                </Tooltip>
              );
            }
          },
          {
            title: "Driver",
            field: "default_driver",
            editable: "never",

            cellStyle: {
              width: "122px"
            },
            headerStyle: {
              width: "122px"
            },
            searchable: false,
            customSort: (a, b) => {
              const driverA = a.default_driver;
              const driverB = b.default_driver;
              const fullNameA = driverA
                ? driverA.first_name + " " + driverA.last_name
                : "";
              const fullNameB = driverB
                ? driverB.first_name + " " + driverB.last_name
                : "";
              return compare(fullNameA, fullNameB);
            },
            render: rowData => {
              const driver = rowData.default_driver;
              return (
                <Tooltip
                  title={
                    driver ? driver.first_name + " " + driver.last_name : ""
                  }
                  placement="bottom-start"
                  classes={{ tooltip: classes.tooltip }}
                  enterDelay={1000}
                >
                  <span id="vehiclesRow-defaultDriver">
                    {driver ? driver.first_name + " " + driver.last_name : ""}
                  </span>
                </Tooltip>
              );
            }
          },
          {
            title: "Start Location",
            field: "start_location",
            editable: "never",

            cellStyle: {
              width: "92px"
            },
            headerStyle: {
              width: "92px"
            },
            searchable: false,

            customSort: (a, b) =>
              sortAddresses(a.start_address, b.start_address),
            render: rowData => {
              return (
                <Tooltip
                  title={rowData.start_address?.formatted_address || ""}
                  placement="bottom-start"
                  classes={{ tooltip: classes.tooltip }}
                  enterDelay={1000}
                >
                  <span id="vehiclesRow-startLocation">
                    {rowData.start_address?.formatted_address || ""}
                  </span>
                </Tooltip>
              );
            }
          },
          {
            title: "End Location",
            field: "end_location",
            editable: "never",

            cellStyle: {
              width: "86px"
            },
            headerStyle: {
              width: "86px"
            },
            searchable: false,

            customSort: (a, b) => sortAddresses(a.end_address, b.end_address),
            render: rowData => {
              return (
                <Tooltip
                  title={rowData.end_address?.formatted_address || ""}
                  placement="bottom-start"
                  classes={{ tooltip: classes.tooltip }}
                  enterDelay={1000}
                >
                  <span id="vehiclesRow-endLocation">
                    {rowData.end_address?.formatted_address || ""}
                  </span>
                </Tooltip>
              );
            }
          },
          {
            title: "Max. Units",
            field: "quantity",
            editable: "never",
            cellStyle: {
              width: "62px"
            },
            headerStyle: {
              width: "62px"
            },
            searchable: false,
            customSort: (a, b) =>
              sortUnitsWeightVolume(+a.quantity, +b.quantity, defaultCapacity),
            render: rowData => {
              const { quantity } = rowData;
              return (
                <span id="vehiclesRow-quantity">
                  {quantity === defaultCapacity ? "" : quantity}
                </span>
              );
            }
          },
          {
            title: "Max. Weight",
            field: "weight",
            editable: "never",
            cellStyle: {
              width: "71px"
            },
            headerStyle: {
              width: "71px"
            },
            searchable: false,
            customSort: (a, b) =>
              sortUnitsWeightVolume(+a.weight, +b.weight, defaultWeight),
            render: rowData => {
              const { weight } = rowData;
              return (
                <span id="vehiclesRow-weight">
                  {weight === defaultCapacity ? "" : weight}
                </span>
              );
            }
          },
          {
            title: "Max. Volume",
            field: "volume",
            editable: "never",
            cellStyle: {
              width: "75px"
            },
            headerStyle: {
              width: "75px"
            },
            searchable: false,
            customSort: (a, b) =>
              sortUnitsWeightVolume(+a.volume, +b.volume, defaultVolume),
            render: rowData => {
              const { volume } = rowData;
              return (
                <span id="vehiclesRow-volume">
                  {volume === defaultCapacity ? "" : volume}
                </span>
              );
            }
          },
          {
            title: "Tags",
            field: "tags",
            searchable: false,
            editable: "never",
            cellStyle: {
              width: "45px"
            },
            headerStyle: {
              width: "45px"
            },
            customSort: (a, b) => +a.tags.length - +b.tags.length,
            render: rowData => {
              return (
                <Tooltip
                  title={
                    rowData.tags.length
                      ? rowData.tags.map(tag => <span>{tag.name}</span>)
                      : ""
                  }
                  placement="bottom-start"
                  classes={{ tooltip: classes.tagTooltip }}
                  enterDelay={1000}
                >
                  <span id="vehiclesRow-tags">{rowData.tags.length}</span>
                </Tooltip>
              );
            }
          }
        ]}
      />
      {/* <ListView
        open={open}
        setCurrentAction={setCurrentAction}
        setCurrentVehicle={setCurrentVehicle}
        setUploadOpen={setUploadOpen}
        handleClose={handleClose}
        loaded={vehiclesListLoaded}
        handleMultipleDelete={handleMultipleDelete}
        handleMultipleDownload={handleMultipleDownload}
        handleAdd={

        }
        handleEdit={handleEdit}
        data={sortVehiclesByName(vehicleTypes)}
        setData={setVehicles}
        handleDelete={handleDelete}
        label={"vehicle"}
        loading={loading}
        selected={selected}
        setSelected={setSelected}
        compareFunc={handleFilter}
        CustomIcon={({ profile, ...props }) => {
          return profile === "bicycle" ? (
            <img src={bicycleIcon} alt="" {...props} />
          ) : (
            <LocalShippingIcon {...props} fontSize="small" />
          );
        }}
        getInfo={getVehicleInfo}
        setBackFromEditAction={setBackFromEditAction}
        backFromEditAction={backFromEditAction}
      /> */}
      {/* <ConfirmDialog
        open={confirmDialogState.open}
        handleClose={() => setConfirmDialogState({ open: false })}
        action={confirmDialogState.action}
        title={confirmDialogState.title}
        body={confirmDialogState.body}
      /> */}
    </>
  );
}

function mapStateToProps(state) {
  return {
    vehicles: state.project.vehicles,
    vehicleTypes: state.project.vehicleTypes,
    project: state.project,
    userType: state.auth.userData.userType,
    editId: state.extendable.id,
    selectedVehicles: state.project.selectedVehicles,
    projects: state.account.projects,
    plan:
      (state.auth.userData.organisationSite &&
        state.auth.userData.organisationSite.organisation.plan) ||
      {},
    payment: state.account.payment,
    vehiclesListLoaded: state.loading.vehiclesListLoaded,
    vehicleExpanded: state.account.accountDialog === "vehicles",
    subscriptionStatus:
      (state.auth.userData.organisationSite &&
        state.auth.userData.organisationSite.organisation
          .subscription_status) ||
      ""
  };
}

export default connect(mapStateToProps, {
  setVehicles,
  setVehicleTypes,
  setSelectedVehicles,
  setCurrentWindow,
  setSolution,
  setProject,
  setProjects,
  setChangedVehicles,
  setInfoDialog,
  setExtendableId,
  setExtendableType
})(withSnackbar(VehiclesOverviewDialog));
